import { config } from '@abyss/web/tools/config';

//Example
export const APP_NAME = config('APP_NAME');
export const API_URL = config('API_URL');

const frontendOrigin =
  config('FRONTEND_ORIGIN') ||
  config('VITE_FRONTEND_ORIGIN') ||
  config('NEXT_PUBLIC_FRONTEND_ORIGIN') ||
  '';

export const AzureClientId =
  config('AZURE_CLIENT_ID') ||
  config('SSO_AZURE_CLIENT_ID') ||
  config('VITE_AZURE_CLIENT_ID') ||
  config('NEXT_PUBLIC_AZURE_CLIENT_ID') ||
  '';

export const AzureTenantId =
  config('AZURE_TENANT_ID') ||
  config('SSO_AZURE_TENANT_ID') ||
  config('VITE_AZURE_TENANT_ID') ||
  config('NEXT_PUBLIC_AZURE_TENANT_ID') ||
  'common';

export const AzureAuthority =
  config('AZURE_AUTHORITY') ||
  config('VITE_AZURE_AUTHORITY') ||
  config('NEXT_PUBLIC_AZURE_AUTHORITY') ||
  `https://login.microsoftonline.com/${AzureTenantId}`;

export const AzureLoginHint =
  config('AZURE_LOGIN_HINT') ||
  config('SSO_AZURE_LOGIN_HINT') ||
  config('VITE_AZURE_LOGIN_HINT') ||
  config('NEXT_PUBLIC_AZURE_LOGIN_HINT') ||
  '';

export const AzureRedirectUri =
  config('AZURE_REDIRECT_URI') ||
  config('SSO_AZURE_REDIRECT_URI') ||
  config('VITE_AZURE_REDIRECT_URI') ||
  config('NEXT_PUBLIC_AZURE_REDIRECT_URI') ||
  (frontendOrigin ? `${frontendOrigin}/getToken` : '');

export const AzurePostLogoutRedirectUri =
  config('AZURE_POST_LOGOUT_REDIRECT_URI') ||
  config('VITE_AZURE_POST_LOGOUT_REDIRECT_URI') ||
  config('NEXT_PUBLIC_AZURE_POST_LOGOUT_REDIRECT_URI') ||
  (frontendOrigin ? `${frontendOrigin}/login` : '');

export const AzureScopes = (
  config('AZURE_SCOPES') ||
  config('SSO_AZURE_SCOPE') ||
  config('VITE_AZURE_SCOPES') ||
  config('NEXT_PUBLIC_AZURE_SCOPES') ||
  'openid profile email User.Read'
)
  .split(/[\s,]+/)
  .filter(Boolean);

// Scope used when acquiring tokens for your own Flask API.
// Produces a token whose aud = "api://<clientId>" which the backend validates.
// AZURE_SCOPES (above) covers OIDC + Graph and is only used at login time.
export const AzureApiScope =
  config('AZURE_API_SCOPE') ||
  config('VITE_AZURE_API_SCOPE') ||
  config('NEXT_PUBLIC_AZURE_API_SCOPE') ||
  `api://${AzureClientId}/openid`;
